<script>
export default {
	data() {
		return {
			errorTimeout: null,
			warningTimeout: null
		};
	},
	methods: {
		announceError(error) {
			this.$announcer.assertive(this.$t('error'));
			clearTimeout(this.errorTimeout);
			this.errorTimeout = setTimeout(() => {
				this.$announcer.assertive(error);
			}, 200);
		},

		announceWarning(warning) {
			this.$announcer.assertive(this.$t('warning'));
			clearTimeout(this.warningTimeout);
			this.warningTimeout = setTimeout(() => {
				this.$announcer.assertive(warning);
			}, 200);
		},

		announceDelay(milliseconds) {
			return new Promise(resolve => setTimeout(resolve, milliseconds));
		}
	}
};
</script>
